import { API } from "aws-amplify";
import { Auth } from "aws-amplify";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { PageHeader, ListGroup, ListGroupItem } from "react-bootstrap";
import "./Home.css";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      user: {},
      events: []
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }

    try {
      const user = await this.getUser();
      const events = await this.getEvents(user.username);
      this.setState({ user, events });
    } catch (e) {
      // console.log(JSON.stringify(e));
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  getEvents(username) {
    return API.get("events", "/events/users/" + username);
  }

  async getUser() {
    // Get the logged in user
    return await Auth.currentAuthenticatedUser();
  }

  formatEventText(event) {
    var eventText = "Event Date: " + event.EventDate;

    if(event.EventEndDate !== undefined && event.EventEndDate !== null) {
      eventText = eventText + "\nEvent End Date: " + event.EventEndDate;
    }

    return eventText;
  }

  renderEventsList(events) {
    return [{}].concat(events).map(
      (event, i) =>
        i !== 0
          ? <ListGroupItem
              key={event.EventID}
              href={`/events/${event.EventID}`}
              onClick={this.handleEventClick}
              header={event.Title}
              style={{whiteSpace: "pre-line"}}
            >
              {this.formatEventText(event)}
            </ListGroupItem>
          : <ListGroupItem
              key="new"
              href="/events/new"
              onClick={this.handleEventClick}
            >
              <h4>
                <b>{"\uFF0B"}</b> Create a new event
              </h4>
            </ListGroupItem>
    );
  }

  handleEventClick = event => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute("href"));
  }

  renderLander() {
    return (
      <div className="lander">
        <h1>My Cloud Line</h1>
        <p>A customizable event timeline repository</p>
        <div>
          <Link to="/login" className="btn btn-info btn-lg">
            Login
          </Link>
          <Link to="/signup" className="btn btn-success btn-lg">
            Signup
          </Link>
        </div>
      </div>
    );
  }

  renderEvents() {
    return (
      <div className="Events">
        <PageHeader>Your Events</PageHeader>
        <ListGroup>
          {!this.state.isLoading && this.renderEventsList(this.state.events)}
        </ListGroup>
      </div>
    );
  }

  render() {
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderEvents() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js